<template>
  <div>
    <template v-if="viewAction">
      <b-dropdown
        split
        :text="$t('common.view')"
        variant="outline-primary"
        right
        size="sm"
        @click="$router.push(viewAction)"
      >
        <template #button-content>
          <feather-icon
            icon="EyeIcon"
          />
          {{ $t('common.view') }}
        </template>
        <slot name="extra-items" />
        <b-dropdown-item
          v-if="!hideEdit"
          @click="$router.push(editAction)"
        >
          <feather-icon icon="EditIcon" />
          <span
            class="align-middle ml-50"
            v-text="$t('common.update')"
          />
        </b-dropdown-item>
        <b-dropdown-item
          v-if="deleteAction && dataId"
          @click="deleteAction(dataId)"
        >
          <feather-icon icon="XIcon" />
          <span
            class="align-middle ml-50"
            v-text="$t('common.delete')"
          />
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <template v-else-if="deleteAction && dataId">
      <b-dropdown
        split
        :text="$t('common.update')"
        variant="outline-primary"
        right
        size="sm"
        @click="$router.push(editAction)"
      >
        <template #button-content>
          <feather-icon
            icon="EditIcon"
          />
          {{ $t('common.update') }}
        </template>
        <b-dropdown-item
          v-if="deleteAction && dataId"
          @click="deleteAction(dataId)"
        >
          <feather-icon icon="XIcon" />
          <span
            class="align-middle ml-50"
            v-text="$t('common.delete')"
          />
        </b-dropdown-item>
      </b-dropdown>
    </template>
    <template v-else>
      <b-button
        :to="editAction"
        variant="outline-primary"
        size="sm"
      >
        <feather-icon
          icon="EditIcon"
        />
        {{ $t('common.update') }}
      </b-button>
    </template>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem, BButton } from 'bootstrap-vue'

export default {
  name: 'ListButtons',
  components: {
    BDropdown, BDropdownItem, BButton,
  },
  props: {
    viewAction: {
      type: String,
      default: null,
    },
    editAction: {
      type: String,
      required: true,
    },
    dataId: {
      type: String,
      required: false,
      default: null,
    },
    deleteAction: {
      type: Function,
      required: false,
      default: null,
    },
    hideEdit: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>

</style>
